import {Sprite_MapInvHeader} from "./InventoryHeader.sprite";
import {InventoryFooterSprite} from "./InventoryFooter.sprite";
import {Sprite_MainInvItems} from "./MainInventoryItems.sprite";

export class InventoryMainSprite extends KDCore.Sprite {
  constructor() {
    super();
    this._create();
  }

  isMouseIn() {
    const pos = TouchInput;
    const rx = KDCore.SDK.canvasToLocalX(this._background, pos.x);
    const ry = KDCore.SDK.canvasToLocalY(this._background, pos.y);
    return rx >= 0 && ry >= 0 && rx <= this._background.width && ry <= this._background.height;
  }

  createMain() {
    this._createHeader();
    this._createContent();
    this._createFooter();
  }

  destroyMain() {
    this._main.removeChild(this._header);
    this._main.removeChild(this._footer);
    this._main.removeChild(this._content);
    this._header.destroy();
    this._footer.destroy();
    this._content.destroy();

    this._header = null;
    this._content = null;
    this._footer = null;
  }

  playStartSE() {
    KDCore.Utils.playSE(this.settings.openInventorySE);
  }

  _create() {
    this._loadSettings();
    this._createBackground();
    this._main = new Sprite();
    this.add(this._main);
  }

  _loadSettings() {
    this.settings = this._settingsJSON();
    this.moveByJson(this.settings);
    this.visible = this.settings.visible;
  }

  _settingsJSON() {
    return YsServices.equipmentService.getUIMapInventorySettings();
  }

  _createBackground() {
    this._background = YsServices.equipmentService.FromImgI(this.settings.backgroundImg);
    this.add(this._background);
  }

  _createHeader() {
    this._header = new Sprite_MapInvHeader();
    this._main.addChild(this._header);
  }

  _createContent() {
    this._content = new Sprite_MainInvItems();
    this._main.addChild(this._content);
  }

  _createFooter() {
    this._footer = new InventoryFooterSprite();
    this._main.addChild(this._footer);
  }
}
